export const countPerPage = 30;
export const plantGroupId = 2;
export const defaultColumns = [
  {
    data: 'common_name',
    label: 'Common Name',
    searchable: true,
    orderable: true
  },
  {
    data: 'scientific_name',
    label: 'Scientific Name',
    searchable: true,
    orderable: true
  },
  {
    data: 'summary_type',
    label: 'Summary Type',
    searchable: true,
    orderable: true
  }
];

export const wetlandColumn = {
  data: 'has_wetland',
  searchable: true,
  orderable: true
}

export const osrColumn = {
  data: 'has_osr',
  searchable: true,
  orderable: false
}
export const cmsProfileColumn = {
  data: 'has_cms_profile',
  searchable: true,
  orderable: true
}
export const modelOptions = [{
  label: 'Full',
  value: 'Full'
},
{
  label: 'Forested',
  value: 'Forested'
},
{
  label: 'Prairie',
  value: 'Prairie'
},
{
  label: 'Basic',
  value: 'Basic'
}];
export const wetlandOption = [
  {
    label: 'All',
    value: ''
  },
  {
    label: 'Wetland',
    value: '1'
  },
  {
    label: 'Non-wetland',
    value: '0'
  }];

export const osrOption = [
  // {
  //   label: 'All',
  //   value: ''
  // },
  {
    label: 'OSR',
    value: '1'
  },
  {
    label: 'Non-OSR',
    value: 'null'
  }];
export const cmsProfileOption = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export const sppGroupOption = [{ id: 1, fullName: 'Birds', shortName: 'birds' },
  { id: 2, fullName: 'Vascular Plants', shortName: 'vplants' },
  { id: 3, fullName: 'Soil Mites', shortName: 'mites' },
  { id: 4, fullName: 'Lichens', shortName: 'lichens' },
  { id: 5, fullName: 'Bryophytes', shortName: 'bryophtes' },
  { id: 6, fullName: 'Aquatic Inveterbrates', shortName: 'invertebra' },
  { id: 7, fullName: 'Mammals', shortName: 'mammals' },
  { id: 8, fullName: 'Non-native Vascular Plants', shortName: 'nnplants' },
  { id: 20, fullName: 'Habitat Elements', shortName: 'habitats' },
  { id: 9, fullName: 'Amphibians', shortName: 'amphibians' }
];

export const getGroupNameById = (id) => {
  return sppGroupOption.find(x => x.id === id)?.fullName;
}

export const getGroupIdByName = (name) => {
  return sppGroupOption.find(x => x.fullName === name)?.id;
}
